<template>
  <div class="news">
    <drug-guide title="企业公告" :headimg="notHead" :enimg="enImg"></drug-guide>
    <div class="newsdetail">
      <div class="newsdetail-head">
        <div class="newsdetail-title">{{ detail.title }}</div>
        <div class="newsdetail-label"  style="margin-top: 45px;">
          <div class="newsdetail-time">发布时间：{{ detail.ctime }}</div>
          <div class="newsdetail-look">浏览：{{ detail.view }}</div>
        </div>
      </div>
      <div class="newsdetail-con">
        <img :src="detail.thumb" alt="">
        <div v-html="detail.content"></div>
      </div>
      <div class="newsdetail-page">
        <div class="newsdetail-prev" :class="detail.prev_id ? '' : 'on'" @click="getPrev(detail.prev_id)">上一篇</div>
        <div class="newsdetail-return" @click="getReturn()">返回列表</div>
        <div class="newsdetail-next" :class="detail.next_id ? '' : 'on'" @click="getNext(detail.next_id)">下一篇</div>
      </div>
    </div>
    <drug-footer></drug-footer>
  </div>
</template>

<script>
import DrugFooter from "../../components/DrugFooter";
import DrugGuide from "../../components/DrugGuide";
import { getDetail } from "@/api/index";
export default {
  name: "NoticeDetail",
  components: {
    DrugFooter,
    DrugGuide
  },
  data() {
    return {
      notHead: "static/images/notice/not-head.png",
      enImg: "static/images/notice/not-en.png",
      detail: {}
    }
  },
  created() {
    var id = this.$route.query.id;
    getDetail(id).then((res) => {
      if(res.data.code == 1) {
        this.detail = res.data.data;
      }
    })
  },
  watch: {
    "$route.query.id"() {
      document.documentElement.scrollTop = 0;
      var id = this.$route.query.id;
      getDetail(id).then((res) => {
        if(res.data.code == 1) {
          this.detail = res.data.data;
        }
      })
    }
  },
  methods: {
    // 上一篇
    getPrev(id) {
      if(id) {
        this.$nextTick(() => {
          this.$router.replace({
            path: "/notice/detail",
            query: { id }
          }, () => {})
        })
      }
    },
    // 返回列表
    getReturn() {
      this.$router.replace({
        path: "/notice"
      })
    },
    // 下一篇
    getNext(id) {
      if(id) {
        this.$nextTick(() => {
          this.$router.replace({
            path: "/notice/detail",
            query: { id }
          }, () => {})
        })
      }
    }
  },
  mounted() {
    this.$store.commit("getactive", 4);
  }
}
</script>

<style lang="scss" scoped>
 .news {
  .newsdetail {
    width: 80%;
    height: auto;
    overflow: hidden;
    margin: 20px auto 0 auto;
    background-color: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    .newsdetail-head {
      text-align: center;
      padding: 40px 0;
      .newsdetail-title {
        font-size: 28px;
        height: 40px;
        line-height: 40px;
        font-weight: 500;
        color: #002244;
        font-family: "PingFang SC-Medium", "PingFang SC";
      }
      .newsdetail-label {
        height: 20px;
        line-height: 20px;
        color: #BAC0C8;
        font-size: 16px;
        display: flex;
        justify-content: center;
        margin-top: 16px;
        .newsdetail-look {
          border-left: 1px solid #BAC0C8;
          padding-left: 10px;
          margin-left: 10px;
        }
      }
    }
    .newsdetail-con {
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
      padding: 50px 50px;
      img {
        width: 100%;
        display: block;
        margin-bottom: 30px;
      }
    }
    .newsdetail-page {
      cursor: pointer;
      padding: 37px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      color: #7C828A;
      font-size: 16px;
      div {
        border: 1px solid #ddd;
        height: 40px;
        line-height: 40px;
        padding: 0 36px;
        &.on {
          color: #cecece;
        }
      }
      .newsdetail-return {
        margin: 0 20px;
      }
    }
  }
 }
</style>



// WEBPACK FOOTER //
// src/pages/notice/detail.vue